export default __webpack_public_path__ + "static/media/v_wdt_c_2.a2975009.mp3";